import cookie from '@snapask/common-components/dist/utils/cookie';
import config from '@dragonfruit/config';

const { COOKIE_DOMAIN } = config;

const snapCookie = new cookie(COOKIE_DOMAIN);

export function getAppsflyerFromCookie() {
  return snapCookie.getAppsFlyerConversionData();
}



// WEBPACK FOOTER //
// ./app/utils/appsflyers.js